import { AccessPlan } from 'models/access-plan'

/** Tenant id → plans from GetAllAccessPlans */
export type AccessPlansByTenant = Record<string, AccessPlan[] | undefined>

/**
 * Restricted plans that can be assigned on the users UI (same filter as the selector).
 * `undefined` = plans not loaded yet for this tenant.
 */
export function getAssignableRestrictedAccessPlans(
  allAccessPlans: AccessPlansByTenant,
  tenantId: string | number | undefined,
): AccessPlan[] | undefined {
  if (tenantId === undefined || tenantId === '') return undefined
  const plans = allAccessPlans[String(tenantId)]
  if (plans === undefined) return undefined
  return plans.filter(
    (plan) =>
      plan.accessType === 'restricted' ||
      (plan as { access_type?: string }).access_type === 'restricted',
  )
}
